module.exports = __webpack_public_path__ + "static/media/sub_menu_eyewear_black.e3b02be5.png";